import { usePropertyUrl } from '~/utilities/usePropertyUrl';
import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export function useIsSI(): boolean {
  const propertyUrl = usePropertyUrl();

  // Get the domain of the property URL
  const domain = propertyUrl.split('/')[2];

  // Also checking for a beta URL that is used for testing new SI sites before they go live
  return (
    domain.includes('si.com') ||
    propertyUrl.includes('https://mmsport.minutemediabeta.com/www.si.com')
  );
}

export function useIsSICore(): boolean {
  const propertyUrl = usePropertyUrl();

  return propertyUrl.endsWith('www.si.com');
}

export function useIsSIWG(): boolean {
  const {
    property,
    payloadToSSR: { pagePath },
  } = useContext(AppDataContext);

  // TODO: remove the page path check after the launch of SIWG and just use the property check
  return (
    property === 'si_womens_games' || pagePath.includes('/si_womens_games')
  );
}
